import { render, staticRenderFns } from "./ComplexModal.vue?vue&type=template&id=9fda9e4e&"
import script from "./ComplexModal.vue?vue&type=script&lang=js&"
export * from "./ComplexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports